$(document).ready(function() {

    // Si un utilisateur a véritablement cliqué sur le filtre "Tous", alors on le rajoute dans "tous_clicked"
    tous_clicked = {};

    $(document).on('as4-Criterion-Change', function(e, idSearch, idCriterionGroup, idCriterion, criterionName, groupType) {
        // Si "Tous" est cliqué alors on le rajoute dans "tous_clicked", sinon on le supprime
        if (idCriterion === '') {
            tous_clicked[idCriterionGroup] = true;
        } else {
            if (tous_clicked[idCriterionGroup] !== undefined) {
                delete tous_clicked[idCriterionGroup];
            }
        }
    });

    let id_search_reset = 0;
    let id_criterion_group_reset = 0;

    /**
     * #9625, quand on reset un group, on stock les ids pour pouvoir intevenir après
     * (l'evenement as4-Criterion-Group-Reset se joue au clic et non pas à l'affichage des résultats)
     */
    $(document).on('as4-Criterion-Group-Reset', function(e, idSearch, idCriterionGroup) {
        id_search_reset = idSearch;
        id_criterion_group_reset = idCriterionGroup;
    });

    /**
     * #9625 au lieu d'afficher "Tous" quand on reset un groupe, on affiche le nom du groupe
     */
    $(document).on('as4-After-Set-Results-Contents', function(e, idSearch, idCriterionGroup, idCriterion, criterionName, groupType) {
        if (id_search_reset !== 0) {
            var option_label_disabled = $('#PM_ASCriterionGroupSelect_'+id_search_reset+'_'+id_criterion_group_reset).find('option[value=" "]');
            if (option_label_disabled.length > 0) {
                $('#PM_ASCriterionGroupSelect_'+id_search_reset+'_'+id_criterion_group_reset).find('option[value=" "]').prop('selected', true);
            }
            id_search_reset = 0;
            id_criterion_group_reset = 0;
        }
    });

    $('select.PM_ASCriterionGroupSelect').each(function() {
        addDisabledOptionFilter($(this));
    });

    changeTextBtnDisplayAllFilters();

    $(document).on('as4-Before-Response-Callback', function() {
        $('select.PM_ASCriterionGroupSelect').each(function() {
            addDisabledOptionFilter($(this));
        });

        changeTextBtnDisplayAllFilters();
    });

    /**
     * Permet d'afficher les filtres en  mobile
     */
    $(document).on('click', '#filter-mobile-btn', function(e) {

        $('.PM_ASBlockOutput .card-block').slideToggle('fast');
        $('.PM_ASBlockOutput .card-header').click();
    });


    // on scroll down
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100 && $('.back-to-top').length > 0) {
            $('.back-to-top').fadeIn();
        }
        else {
            $('.back-to-top').fadeOut();
        }
    });

    $(document).on('click', '.back-to-top', function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });

    /**
     * #9775
     */
    $(document).on('click', '.product-miniature .fmm_sticker_base_span img', function(e) {
        let product_miniature = $(this).closest('.product-miniature');

        if (product_miniature.length > 0) {
            let product_link = product_miniature.find('.product-miniature__thumb-link').attr('href');

            if (product_link !== undefined) {
                window.location.href = product_link;
            }
        }
    });
});

/**
 * Fonction qui ajoute pour les selectbox des filtres une option au tout début du selectbox
 * qui a le nom du groupe de filtre et qui est désactivée
 */
function addDisabledOptionFilter(jQueryEl) {

    /**
     * On est obligé de rajouté un espace dans la value car selectize confond le "Tous"
     * qui a également une valeur vide et cette option
     */
    var existing_element = jQueryEl.find('option[value=" "]');

    // Si il existe déjà, on ne le rajoute pas
    if (existing_element.length > 0) {
        return;
    }

    var id_criterion_group = jQueryEl.attr('data-id-criterion-group');
    var val_selected = jQueryEl.find(':selected').val();
    var selected_extra = '';

    /**
     * On vérifie qu'on select le nouveau filtre uniquement si l'utilisateur n'a pas cliqué sur "Tous" 
     */
    if ((val_selected == '' || val_selected == ' ') && tous_clicked[id_criterion_group] === undefined) {
        selected_extra = 'selected';
    }

    var name_option = jQueryEl.closest('.PM_ASCriterions').find('.PM_ASCriterionsGroupName').text();

    jQueryEl.prepend('<option value=" " disabled ' + selected_extra + '>'+name_option+'</option>');
}

function changeTextBtnDisplayAllFilters() {
    if($('.PM_ASShowCriterionsGroupHidden').hasClass('PM_ASShowCriterionsGroupHiddenOpen')) {
        $('.PM_ASShowCriterionsGroupHidden .PM_ASShowCriterionsGroupHidden__link').html($('.PM_ASShowCriterionsGroupHidden').attr('data-hide-filters-label'));
    } else {
        $('.PM_ASShowCriterionsGroupHidden .PM_ASShowCriterionsGroupHidden__link').html($('.PM_ASShowCriterionsGroupHidden').attr('data-show-filters-label'));
       
    }
}